export default __webpack_public_path__ + "media/zurb/img/ecommerce/bn_2-2e639f2d5a346390a29c1b1c575ae7ba.png";